"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInABTest = exports.getABTest = void 0;

var _platformId = require("./platform-id");

var LAST_ABTESTS = null;
var ABTEST_CACHE_MAP = null;

var retrieveABTests = function retrieveABTests(currentAbtests) {
  if (LAST_ABTESTS !== currentAbtests || !LAST_ABTESTS) {
    // abtest has changed, login/logout/hard-refresh
    LAST_ABTESTS = currentAbtests;
    ABTEST_CACHE_MAP = currentAbtests.reduce(function (abtestCacheMap, abtest) {
      abtestCacheMap[abtest.name] = abtest;
      return abtestCacheMap;
    }, {});
  }

  return ABTEST_CACHE_MAP;
};

var showDebugError = function showDebugError(abTestName, testFound, currentPlatformId) {
  /*
   * The current setup below is a short-term solution to our ABTest error problem.
   * Long term we should move ABTests that are cross-platform to the SHARED_ABTEST
   * constant so that we don't have to run this platform check.
   * It's ugly, but sometimes it do be like that.
   * Mackenzie Clark, 2-20-2020
   */
  // Make sure we need to check for a warning before testing logic
  if (process.env.NODE_ENV === 'development' && !testFound && currentPlatformId) {
    var testPlatformMatchesCurrentPlatform;

    if (abTestName.indexOf('desktop') > -1) {
      testPlatformMatchesCurrentPlatform = currentPlatformId === _platformId.PLATFORM_ID.DESKTOP;
    } else if (abTestName.indexOf('mobile') > -1) {
      testPlatformMatchesCurrentPlatform = currentPlatformId === _platformId.PLATFORM_ID.MOBILEWEB;
    } else {
      // If test doesn't contain "desktop" or "mobile", it is shared i.e. coreweb.mytest
      // and should be found regardless of current platform
      testPlatformMatchesCurrentPlatform = true;
    }

    if (testPlatformMatchesCurrentPlatform) {
      console.error("ERROR: AB test ".concat(abTestName, " does not exist"));
    }
  }
}; // this is the legacy version of isInAbtest function, it doesn't support variants
// it's still here for backward compatibility


var getABTest = function getABTest(abTestName, abTests, currentPlatformId) {
  var abTestMap = retrieveABTests(abTests);
  var foundTest = abTestMap && abTestMap[abTestName];
  showDebugError(abTestName, !!foundTest, currentPlatformId);
  return !!(foundTest && foundTest.isInTest === true);
}; // This is the isInAbtest function that will take variantName into the check if it's present.
// without variantName it behaves exactly as the legacy one
// the argument is object instead of list of arguments.


exports.getABTest = getABTest;

var isInABTest = function isInABTest(_ref) {
  var abTests = _ref.abTests,
      abTestName = _ref.abTestName,
      currentPlatformId = _ref.currentPlatformId,
      variantName = _ref.variantName;
  var abTestMap = retrieveABTests(abTests);
  var foundTest = abTestMap && abTestMap[abTestName];
  showDebugError(abTestName, !!foundTest, currentPlatformId);

  if (variantName) {
    return !!(foundTest && foundTest.isInTest === true && foundTest.variantName === variantName);
  }

  return !!(foundTest && foundTest.isInTest === true);
};

exports.isInABTest = isInABTest;